<template>
  <el-dialog
    title="申报信息"
    :visible.sync="visible"
    :close-on-click-modal="true"
    :before-close="handleClose"
    append-to-body
    width="80%"
		top="5vh"
  >
    <!-- title 自定义插槽 -->
    <template #title>
      <div class="dialog-header">
        <span style="margin-right: 15px">申报列表</span>
        <el-button type="primary" @click="exportExcel" size="small"
          >导出申报表</el-button
        >
      </div>
    </template>
    <el-card style="margin-top: -10px;">
      <m-search
        :searchItemList="eventUserSearchItemList"
        @on-search-submit="onEventUserSearchSubmit"
        @search="onEventUserSearchSubmit"
      ></m-search>
      <div class="flex-center radio-cell" style="justify-content: flex-start;margin-top: 10px;">
        <el-radio-group
          v-model="eventUserSearch.processStatus"
          @input="getEventUserList()"
        >
          <el-radio-button label>全部({{ eventUserCount }})</el-radio-button>
          <el-radio-button :label="2"
            >通过({{ passCount }})</el-radio-button
          >
          <el-radio-button :label="0"
            >未通过({{ refuseCount }})</el-radio-button
          >
          <el-radio-button :label="1"
            >未评选({{ checkCount }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <el-table
        :data="eventUserTableList"
        stripe
        border
        :header-cell-style="{
          'font-size': '14px',
          color: '#909399',
          'font-weight': '400',
          background: '#F7F8FA',
        }"
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column align="center" label="申报时间">
          <template slot-scope="scope">
            <div class="flex_center">
              {{ scope.row.createdAt }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="名称">
          <template slot-scope="scope">
            <div class="flex_center">
              <div>{{ scope.row.name ? String(scope.row.name) : "-" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="电话">
          <template slot-scope="scope">
            <div class="flex_center">
              <div>{{ scope.row.phone || "-" }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="评选结果">
          <template slot-scope="scope">
            <div class="flex_center">
              <div>{{ processStatusText(scope.row.processStatus) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
						<div>
							<el-button type="text" @click="showDetail(scope.row)"
								>查看申报信息</el-button
							>
							<el-button type="text" @click="deal(scope.row)"
								>评选</el-button
							>
						</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="eventUserTableList.length > 0" class="flex_end p-sm flexRowCenter">
        <el-pagination
          @current-change="handleCurrentChange1"
          @size-change="handleSizeChange1"
          :current-page.sync="eventUserSearch.page"
          :page-size="eventUserSearch.pageSize"
          layout="total,sizes, prev, pager, next, jumper"
          :total="eventUserCount"
        >
        </el-pagination>
      </div>
    </el-card>
    <PartyMemberInfoDialog
      :visible.sync="showDetailDialog"
      :declareId="declareId"
			@close="showDetailDialog = false"
    />
    <PartyMemberReviewDialog
      :visible.sync="showReviewDialog"
      :name="reviewName"
      :declareId="reviewDeclareId"
      @updateList="getEventUserList()"
    />
  </el-dialog>
</template>

<script>
import PartyMember from '@/axios/api/partyMember.js'
import PartyMemberInfoDialog from './PartyMemberInfoDialog.vue'
import PartyMemberReviewDialog from './PartyMemberReviewDialog.vue'
export default {
  name: "PartyMemberDetailDialog",
	components: {
    PartyMemberInfoDialog,
    PartyMemberReviewDialog
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    detailId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
			show: false,
      eventUserSearch: {
        page: 1,
        pageSize: 10,
      },
			eventUserSearch: {
        page: 1,
        pageSize: 10,
        name: '',
        phone: '',
        company: '',
        id: '',
        processStatus: ''
      },
			eventUserCount: 0,//申报人数弹窗总数
      passCount: 0,//申报人数弹窗已通过
      refuseCount: 0,//申报人数弹窗未通过
			checkCount: 0,//申报人数弹窗未评选
			eventUserTableList: [],
			loading: false,
			showDetailDialog: false,
			dealDialog: false,
			declareId: '',
			detailId3: '',
			detailInfo: {},
			showReviewDialog: false,
			reviewName: '',
			reviewDeclareId: '',
    };
  },
	computed: {
		eventUserSearchItemList() {
      return [
        {
          label: "名称",
          type: "input",
          param: "name",
        },
        {
          label: "电话",
          type: "input",
          param: "phone",
        },
      ];
    },
	},
	watch: {
		visible(val) {
			if (val) {
				this.getEventUserList()
			}
		}
	},
	methods: {
		processStatusText(val) {
      if (val === 2) return '通过'
      if (val === 0) return '未通过'
      if (val === 1) return '未评选'
      return '-'
    },
		onEventUserSearchSubmit(item) {
      this.eventUserSearch.name = item.name;
      this.eventUserSearch.phone = item.phone;
      this.getEventUserList();
    },
    handleClose() {
			console.log('handleClose');
			
      this.$emit("close");
    },
		handleSizeChange1(val) {
      this.eventUserSearch.pageSize = val;
      this.getEventUserList();
    },
    handleCurrentChange1(val) {
      this.eventUserSearch.page = val;
      this.getEventUserList();
    },
		//获取活动用户列表数据
		async getEventUserList() {
      let res = await PartyMember.getApplicationList({...this.eventUserSearch, declareId: this.detailId});
      console.log(res)
      if (res.status == 1) {
        this.eventUserTableList = res.data
        this.eventUserCount = res.extra.totalCount || 0
        this.passCount = res.extra.passCount || 0
        this.refuseCount = res.extra.refuseCount || 0
        this.checkCount = res.extra.checkCount || 0
      }
    },
		showDetail(row) {
			this.declareId = row.id
			this.showDetailDialog = true
		},
		deal(row) {
			this.reviewName = row.name ? String(row.name) : '-'
			this.reviewDeclareId = row.id
			this.showReviewDialog = true
		},
		exportExcel() {
			window.open(`/api/admin/market/exportExcel?id=${this.detailId}`)
		},
		formatDate(ts) {
			if (!ts) return '-'
			// 秒级时间戳转毫秒
			const d = new Date(ts * 1000)
			const y = d.getFullYear()
			const m = (d.getMonth() + 1).toString().padStart(2, '0')
			const day = d.getDate().toString().padStart(2, '0')
			const h = d.getHours().toString().padStart(2, '0')
			const min = d.getMinutes().toString().padStart(2, '0')
			return `${y}-${m}-${day} ${h}:${min}`
		}
	},
};
</script>

<style scoped>
.detail-form {
  padding: 10px 0 0 0;
}
.detail-item {
  margin-bottom: 16px;
  font-size: 15px;
  color: #333;
}
.detail-item .label {
  color: #909399;
  margin-right: 8px;
}
.flexRowCenter {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
